export default "__VITE_PUBLIC_ASSET__d7328817__"